konnyScript(function($){
  
  var winHref = window.location.href;
  if (winHref.indexOf('utm_') != -1){
      var afterHref = winHref.split('newborn-box-2601')

    if($('#knBoxBtn01 a').length){
      var conHref01 = $('#knBoxBtn01 a').prop('href');
      conHref01 = conHref01 + afterHref[1];
      $('#knBoxBtn01 a').prop('href', conHref01);
    }else{
      var conHref01 = $('#knBoxBtn01').prop('href');
      conHref01 = conHref01 + afterHref[1];
      $('#knBoxBtn01').prop('href', conHref01);
    }
    
    if($('#knBoxBtn02 a').length){
      var conHref02 = $('#knBoxBtn02 a').prop('href');
      conHref02 = conHref02 + afterHref[1];
      $('#knBoxBtn02 a').prop('href', conHref02);
    }else{
      var conHref02 = $('#knBoxBtn02').prop('href');
      conHref02 = conHref02 + afterHref[1];
      $('#knBoxBtn02').prop('href', conHref02);
    }
  }
  
  var knBoxBtn01 = $('#knBoxBtn01');
  
  if (knBoxBtn01.length) {
    var fixBtOffset = $('#knBoxBtn01').offset();
    
    var vHeight=$(window).height();
    
    var fixPar1 = parseInt(fixBtOffset.top / vHeight);
    var fixPar2 = fixBtOffset.top % vHeight;
    
    var footerOffset = $('.footer').offset();
    var fixPar3 = footerOffset.top - vHeight;
  
    if(fixPar1 == 0){
      if($(document).scrollTop() > fixPar3 ){
        $('#knBoxBtn01').removeClass('fix');
      }else if( $(document).scrollTop() > 0 ){
        $('#knBoxBtn01').addClass('fix');
      }else{
        $('#knBoxBtn01').removeClass('fix');
      }
    }else{
      if($(document).scrollTop() > fixPar3 ){
        $('#knBoxBtn01').removeClass('fix');
      }else if( $(document).scrollTop() > vHeight*fixPar1 ){
        $('#knBoxBtn01').addClass('fix');
      }else{
        $('#knBoxBtn01').removeClass('fix');
      }
    }
    $(window).scroll(function(){
      if(fixPar1 == 0){
        if($(document).scrollTop() > fixPar3 ){
          $('#knBoxBtn01').removeClass('fix');
        }else if( $(document).scrollTop() > 0 ){
          $('#knBoxBtn01').addClass('fix');
        }else{
          $('#knBoxBtn01').removeClass('fix');
        }
      }else{
        if($(document).scrollTop() > fixPar3 ){
          $('#knBoxBtn01').removeClass('fix');
        }else if( $(document).scrollTop() > vHeight*fixPar1 ){
          $('#knBoxBtn01').addClass('fix');
        }else{
          $('#knBoxBtn01').removeClass('fix');
        }
      }
    });
  }

  $('[id^=\'knbox_swiper_slide\']').each(function(index){
    index = index+1;
    var slidePage1 = '#knbox_swiper_slide'+index+' .swiper-pagination';
    var slidePage2 = '#knbox_swiper_slide'+index+' .swiper-progress';
    var slideScr = '#knbox_swiper_slide'+index+' .swiper-scrollbar';
    var slideNext = '#knbox_swiper_slide'+index+' .swiper-button-next';
    var slidePrev = '#knbox_swiper_slide'+index+' .swiper-button-prev';
    var babySlide = new Swiper(this,{
      slidesPerView:1,
      slidesPerGroup:1,
      spaceBetween:0,
      centeredSlides:true,
      observer:true,
      observeParents:true,
      loop: true,
      pagination:true,
      pagination:{
        el:slidePage2,
        type : 'progressbar'
      },
      scrollbar:{
        el:slideScr,
        hide:true,
      },
      navigation: {
        nextEl: slideNext,
        prevEl: slidePrev,
      },
    });
  });

});